<template>
  <div v-if="hasContent" class="block pt-4 pb-4 pl-2 pr-2 position-relative" :class="{'pl-4 pr-4': tapStore.view, 'delete': del}">
    <ActionHeader class="pl-3 pr-3 mb-4" drag-class="drag-block" :show-drag="blocks?.length > 1"
                  :show-up="block?.orderIndex > 1" :show-down="block?.orderIndex < blocks?.length"
                  @remove="rmBlock" @up="moveUpBlock" @down="moveDownBlock"
                  @pendingRemove="pendingDelete"
                  :change="block.changed && tapStore?.currentTap?.status.id == 3" v-if="!tapStore.view"/>
    <BlockComponents :block="block" :class="{'pointer-events-none': del}"/>
    <div class="d-flex justify-center mt-4" v-if="!tapStore.view">
      <v-icon :icon="AddBlockIcon" size="24" @click="addComponentToBlock(block.id)"/>
    </div>
  </div>
</template>


<script setup lang="ts">
import ActionHeader from '@/components/tap/ActionHeader.vue'
import BlockComponents from './BlockComponents.vue'
import AddBlockIcon from '~/assets/icons/edit/add.vue'
import { useBlocks } from '@/composables/useBlocks'
import {useDialogStore} from "@/stores/dialogStore";
import { useTapStore } from '@/stores/tapStore'
import ListBlockTypes from "@/components/dialogs/ListBlockTypes.vue";
import {computed, ref} from "vue";import { useRoute } from 'vue-router'
import {publicComponentVisible} from '@/components/types/tariffs/publicModel'

const route = useRoute()

const del = ref(false)
const props = defineProps<{ block: any }>()
const { blocks, moveBlock, removeBlock } = useBlocks()
const dialogStore = useDialogStore()
const tapStore = useTapStore()
const hasContent = computed(() => !tapStore.view || props.block.hidden !== true && props.block.blockItems.some(publicComponentVisible))

const addComponentToBlock = (blockId?) => {
  dialogStore.open(ListBlockTypes, {blockId: blockId})
}

const pendingDelete = (val) => {
  del.value = val
}

const moveUpBlock = () => moveBlock(props.block, true)
const moveDownBlock = () => moveBlock(props.block, false)
const rmBlock = () => removeBlock(props.block)
</script>

<style scoped lang="sass">
.block
  --block-content-padding: 16px
  overflow: hidden
  border-radius: 20px
  background: #FFF
  &:not(:last-child)
    margin-bottom: 8px
  &.delete::before
    content: ''
    position: absolute
    inset: 0
    pointer-events: none
    opacity: 0.5
    background: #fff
    z-index: 1
</style>
